import { create } from 'zustand';

import { usePropertyStore } from '@/stores/property-store';

const STORAGE_KEY = 'ridgen-active-property';

interface ActivePropertyStore {
  activePropertyId: string | null;
  setActiveProperty: (id: string) => void;
  initActiveProperty: () => void;
}

function loadFromStorage(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function saveToStorage(id: string | null): void {
  try {
    if (id) {
      localStorage.setItem(STORAGE_KEY, id);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // localStorage unavailable — continue without persistence
  }
}

export const useActivePropertyStore = create<ActivePropertyStore>((set) => ({
  activePropertyId: loadFromStorage(),

  setActiveProperty: (id) => {
    saveToStorage(id);
    set({ activePropertyId: id });
  },

  initActiveProperty: () => {
    // M-07 (Defect Batch M): seed from the primary Property (Property.isPrimary=true)
    // instead of UserPreferences.defaultPropertyId. The property-store may not have
    // hydrated yet — if it hasn't, we leave the active property null and let later
    // store hydration drive the selection (the dashboard / scout pages re-derive
    // from the primary property at render time).
    const persisted = loadFromStorage();
    if (!persisted) {
      const primary = usePropertyStore.getState().properties.find((p) => p.isPrimary);
      const primaryId = primary?.id ?? null;
      if (primaryId) {
        saveToStorage(primaryId);
        set({ activePropertyId: primaryId });
      }
    }
  },
}));
